import { formatDateTime } from '../../../../lib/dateFormat';

/** „26.10.2026 14:30“ — unabhängig von der UI-Sprache; Ungültiges bleibt roh. */
export function fmtDateTime(v: unknown): string {
  if (v == null || v === '') return '—';
  return formatDateTime(String(v), String(v));
}

/**
 * Server-Timestamp → Wert für <input type="datetime-local"> ("YYYY-MM-DDTHH:mm").
 * Reines Datum bekommt 00:00, Leerwert → "". (T1: Deadline als Timestamp)
 */
export function toLocalInput(v: unknown): string {
  if (v == null || v === '') return '';
  const s = String(v).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return `${s}T00:00`;
  const d = new Date(s.replace(' ', 'T'));
  if (isNaN(d.getTime())) return '';
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
